import React from 'react';
import "./style.less";

const HEADER = ["Pokoj", "Lůžka", "Vybavení", "Jména", "Nocí"];
const LINES = [
	["1", "1 manželské + 1 přistýlka", "sprcha, wc", "Novomanželé", "2"],
	["2", "1 manželské", "sprcha, wc", "Ondřej Komosný, Lucie Macková", "1"],
	["3", "1 manželské + 2 přistýlky", "sprcha, wc", "Radka B., Petr. B. Barča B., Petr B. junior", "1"],
	["4", "1 manželské", "sprcha, wc", "Tatínek Mirek, Iva Ú.", "1"],
	["5", "2 samostatné", "Společné soc. Zařízení s pokojem 6", "Tatínek Jirka, Maminka Svatka", "2"],
	["6", "2 samostatné", "Společné soc. Zařízení s pokojem 5", "Babička Marie", "2"],
	["7", "2 samostatné", "sprcha, wc", "Babička Jiřina, Babička Staňka", "1"],
	["8", "2 samostatné", "sprcha, wc", "Sestra Lejča, Michael V.", "1"],
	["9", "1 manželské", "sprcha, wc", "Bratr Peťa, Tamča S., Sabinka", "2"],
	["10", "1 manželské", "sprcha, wc", "Ruda V., Lenka V.", "1"],
	["11", "1 manželské", "sprcha, wc", "Martin Č., Eva Č.", "1"],
	["12", "1 manželské", "sprcha, wc", "Radek Z., Verča P.", "1"],
	["15", "1 manželské", "sprcha, wc", "Jitka K., Luboš V.", "1"],
	["16", "1 manželské", "sprcha, wc", "Bratr Kuba, Zuzka S.", "1"],
	["17", "2 samostatné", "sprcha, wc", "Svědkyně Lucka", "1"],
];

/* eslint-disable react/no-array-index-key */
export default function AccommodationsPage() {
	return <div className="accommodationsPage">
		<h2 className="accommodationsPage__title">Ubytování</h2>
		<p>
			Ubytování je řešené v penzionu kousek od vinařství.
		</p>
		<p>
			Na pokoje je možné se ubytovat v sobotu 28. 5. od rána.
		</p>
		<table className="accommodationsPage__table">
			<thead>
				<tr>
					{HEADER.map((headerItem, ind) => <th key={ind}>{headerItem}</th>)}
				</tr>
			</thead>
			<tbody>
				{LINES.map((lineItem, trInd) => <tr key={trInd}>
					{lineItem.map((item, itemInd) => <td key={itemInd}>
						{item}
					</td>)}
				</tr>)}
			</tbody>
		</table>
	</div>;
}
